import { FormControl, FormGroup } from "@angular/forms";
import { AssessmentPdfGenerator } from "src/app/patients/dashboard-page/assessments-history-tab/assessment-to-pdf";
import { ControlsOf, AssessmentHelpers } from "./shared";

interface PsychosocialFields {
  mood: string[];
  suicidal: boolean;
  otherFindings: string;
}
export type PsychosocialFormGroup = FormGroup<ControlsOf<PsychosocialFields>>;

export const PsychosocialAssessmentHelpers: AssessmentHelpers<PsychosocialAssessment> = {
  createFormGroup: createPsychosocialFormGroup,
  toPDF: psychosocialAssessmentToPDF,
  formToObject: formToPsychosocialAssessment,
  initialState: {
    mood: [],
    suicidal: false,
    otherFindings: '',
  },
};

/**
 * Holds information about the patient's psychosocial assessment.
 */
export class PsychosocialAssessment {
  /**
   * The patient's mood.
   *
   * Options: non-interactive, elated, tearful, withdrawn, and flat.
   */
  mood: string[];

  /**
   * Whether the patient has suicidal thoughts or expression.
   */
  suicidal: boolean;

  /**
   * Any other findings related to psychosocial assessment.
   */
  otherFindings: string;

  constructor(data: Partial<PsychosocialFields>) {
    this.mood = data.mood ?? PsychosocialAssessmentHelpers.initialState['mood'];
    this.suicidal = data.suicidal ?? PsychosocialAssessmentHelpers.initialState['suicidal'];
    this.otherFindings = data.otherFindings ?? PsychosocialAssessmentHelpers.initialState['otherFindings'];
  }
}

// Local functions.

function createPsychosocialFormGroup(psychosocialAssessment?: PsychosocialAssessment) {
  const data = psychosocialAssessment || new PsychosocialAssessment(PsychosocialAssessmentHelpers.initialState);
  return new FormGroup<ControlsOf<PsychosocialFields>>({
    mood: new FormControl<string[] | null>(data.mood),
    suicidal: new FormControl<boolean | null>(data.suicidal),
    otherFindings: new FormControl<string | null>(data.otherFindings),
  });
}

function psychosocialAssessmentToPDF(pdf: AssessmentPdfGenerator, assessment: PsychosocialAssessment): void {
  pdf.addSectionTitle("Psychosocial");
  pdf.addOneColumnText("Mood", assessment.mood.join(", "));
  pdf.addOneColumnText("Suicidal Thoughts/Expressions?", assessment.suicidal ? "Yes" : "No");
  pdf.addOneColumnText("Other Findings", assessment.otherFindings);
  pdf.currY += pdf.newSection;

}

function formToPsychosocialAssessment(fg: PsychosocialFormGroup) {
  return new PsychosocialAssessment({
    mood: fg.controls.mood.value!,
    suicidal: fg.controls.suicidal.value!,
    otherFindings: fg.controls.otherFindings.value!,
  });
}